<template>
  <v-dialog v-model="values.showDialog" @keydown.enter="reloadPage()" persistent max-width="400" scrollable>
    <v-card>
      <v-card-title primary-title class="dialog-warning-title"> ATENÇÃO </v-card-title>
      <v-card-text justify-center>
        <p class="text-md-center">{{values.text}}</p>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="mx-0" flat color="primary" @click.native="reloadPage()">Recarregar página</v-btn>
        <v-btn v-if="values.btnClose" class="mx-0" flat @click.native="close()">Não recarregar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    name: 'PDialogWarning',
    methods: {
      reloadPage () {
        location.reload(true)
      },
      close () {
        this.$store.commit('dialogWarning/change_values', { showDialog: false, btnClose: false })
      }
    },
    computed: {
      values () {
        return this.$store.getters[`dialogWarning/values`] || ''
      }
    }
  }
</script>

<style scoped>
  .dialog-warning-title {
    background-color: #cccccc;
    font-size: 16px;
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/components/shared/PDialogWarning.vue